import { render, staticRenderFns } from "./moreSchool.vue?vue&type=template&id=13b01b02&"
import script from "./moreSchool.vue?vue&type=script&lang=js&"
export * from "./moreSchool.vue?vue&type=script&lang=js&"
import style0 from "./moreSchool.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports